import { handleActions, combineActions } from 'redux-actions';
import actions from '../actions';

const {
  check: { enable, disable },
  update,
  reset,
} = actions.payment;

const defaultState = {
  checking: false,
};

export default handleActions(
  {
    [combineActions(enable, disable, update)]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [reset]: () => defaultState,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/reducers/payment.js